import { render, staticRenderFns } from "./HorizontalTabMenu.vue?vue&type=template&id=3fea3052&"
import script from "./HorizontalTabMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalTabMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTabMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports